"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Compliance() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stats = [{
    value: "24/7",
    unit: "HRS",
    label: "MONITORING"
  }, {
    value: "100",
    unit: "%",
    label: "COMPLIANCE"
  }, {
    value: "0",
    unit: "SEC",
    label: "LATENCY"
  }];
  return <section data-section-id="3104" id="compliance-risk" className="bg-background text-foreground relative overflow-hidden py-24 md:py-40">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")"
    }} />

      <div className="relative mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          {}
          <div ref={imageRef} data-index={0} className={`lg:col-span-5 transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="p-8 md:p-12 lg:p-16 bg-card border border-border">
              <div className="overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717971/img/cyber_security_monitoring.png" alt="AI-driven security dashboard monitoring network traffic in real-time" loading="lazy" decoding="async" className="w-full h-full object-cover aspect-[3/4]" />
              </div>
            </div>
            <p className="font-mono text-xs tracking-widest mt-6 pl-8 md:pl-12 lg:pl-16 text-muted-foreground uppercase">
              Real-time threat intelligence feed.
            </p>
          </div>

          {}
          <div ref={contentRef} data-index={1} className={`lg:col-span-7 lg:pl-8 transition-all duration-1000 delay-150 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-primary mb-10 md:mb-14">
              Risk & Compliance — N° 03
            </p>

            {}
            <h2 className="font-default font-semibold leading-[1.1] tracking-tighter text-foreground mb-12 md:mb-16" style={{
            fontSize: "clamp(2rem, 5vw, 3.5rem)"
          }}>
              Proactive risk
              <br />
              management for the
              <br />
              digital age.
            </h2>

            {}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 mb-14 md:mb-20">
              <p className="font-default text-lg leading-relaxed text-muted-foreground">
                InfinitySecure transforms compliance from a reactive burden into a strategic advantage. We automate risk assessments and regulatory reporting, ensuring your business remains resilient against evolving cyber threats.
              </p>
              <p className="font-default text-lg leading-relaxed text-muted-foreground">
                Our AI-driven engine continuously scans your infrastructure, identifying vulnerabilities before they can be exploited. We provide the clarity and control needed to navigate complex security landscapes with confidence.
              </p>
              <p className="font-default text-lg leading-relaxed text-muted-foreground md:col-span-2 md:max-w-[80%]">
                Whether you are a growing startup or an established enterprise, our scalable solutions ensure your digital assets are protected, compliant, and always ready for the future.
              </p>
            </div>

            {}
            <div className="border-t border-border pt-10 mb-12">
              <div className="grid grid-cols-3 gap-4 md:gap-8">
                {stats.map((stat, i) => <div data-index={i} key={stat.label} className={`${i > 0 ? "border-l border-border pl-4 md:pl-8" : ""}`}>
                    <div className="flex items-baseline gap-1.5">
                      <span className="font-default text-4xl md:text-5xl font-bold text-primary leading-none">
                        {stat.value}
                      </span>
                      {stat.unit && <span className="font-mono text-xs tracking-widest text-primary uppercase">
                          {stat.unit}
                        </span>}
                    </div>
                    <p className="font-mono text-[10px] md:text-xs tracking-[0.2em] uppercase text-muted-foreground mt-3">
                      {stat.label}
                    </p>
                  </div>)}
              </div>
            </div>

            {}
            <Button asChild variant="link" className="font-mono text-xs tracking-[0.25em] uppercase text-primary hover:text-primary/80 p-0 h-auto group">
              <Link to="/RiskCompliancePage">
                Request a Security Assessment
                <ArrowRight className="ml-2 size-3.5 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}